// extracted by mini-css-extract-plugin
export default {"list":"HomeNavigation_list__zr97T","wrap":"HomeNavigation_wrap__Ve64p","item":"HomeNavigation_item__N5Unm","name":"HomeNavigation_name__M4g0T","icon":"HomeNavigation_icon__8vybl"};